import LeadsPipeline from "../components/pages/dashboard/leads/LeadsPipeline";
import { Helmet } from "react-helmet-async";

const Leads = () => {
  return (
    <div className="leads-page">
      <Helmet>
        <title>Prospects | Super User Manager</title>
        <meta
          name="description"
          content="Prospects: capture, follow up and convert contacts into customers"
        />
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_HOST_URL}/control-panel/leads`}
        />
      </Helmet>
      <LeadsPipeline />
    </div>
  );
};

export default Leads;
